import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import { LanguageService } from '../../i18n/language.service';
import { environment } from '../../../environments/environment';

/** How often the topbar badges refresh, on top of the initial load. */
const BADGE_REFRESH_MS = 5 * 60 * 1000;

@Component({
    selector: 'bo-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit, OnDestroy {

    items!: MenuItem[];

    /** Pending decisions behind each space button, shown as red badges. */
    // (Synthèse carries no badge: it is a reading, not a queue.)
    todoBadge = 0;
    studioBadge = 0;

    private badgeTimer?: ReturnType<typeof setInterval>;

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        public languageService: LanguageService,
        private http: HttpClient,
    ) { }

    ngOnInit(): void {
        this.refreshBadges();
        this.badgeTimer = setInterval(() => this.refreshBadges(), BADGE_REFRESH_MS);
    }

    ngOnDestroy(): void {
        if (this.badgeTimer) {
            clearInterval(this.badgeTimer);
        }
    }

    /** Both counts come from cheap endpoints; a failure simply leaves the badge as it was. */
    private refreshBadges(): void {
        this.http.get<{ pending: number }>(`${environment.api}/api/v1/admin/studio/badge`).subscribe({
            next: (res) => { this.studioBadge = res?.pending ?? 0; },
            error: () => undefined,
        });
        // À traiter counts both worlds it shows: the live recommendations and
        // the attention sweep across every other screen.
        let recommendations = 0;
        let attention = 0;
        const apply = () => { this.todoBadge = recommendations + attention; };
        this.http.get<{ recommendations?: unknown[] }>(`${environment.api}/api/v1/admin/overview/recommendations`).subscribe({
            next: (res) => { recommendations = res?.recommendations?.length ?? 0; apply(); },
            error: () => undefined,
        });
        this.http.get<{ total?: number }>(`${environment.api}/api/v1/admin/todo/attention`).subscribe({
            next: (res) => { attention = res?.total ?? 0; apply(); },
            error: () => undefined,
        });
    }
}
